// src/admin/AdminGuard.js
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

const ADMIN_UID = "EhQ2rwY26GY2jl1vhLNvhdBsLAa2";

export default function AdminGuard({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  // Must be signed in
  if (!user) {
    return <Navigate to="/account" replace state={{ from: location }} />;
  }

  // Must be the admin UID
  if (user.uid !== ADMIN_UID) {
    return <Navigate to="/" replace />;
  }

  return children;
}
